import React from 'react';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import MembroUnidadeForm from '../MembroUnidadeForm/MembroUnidadeForm';

interface MembroUnidadeModalProps {
  isOpen: boolean;
  onClose: () => void;
  initialValues?: any;
}

const MembroUnidadeModal: React.FC<MembroUnidadeModalProps> = ({ isOpen, onClose, initialValues }) => {
  const isEditing = initialValues.id !== null;
  const title = isEditing ? 'Editar Usuário' : 'Adicionar Usuário';

  return (
    <ModalTransition>
      {isOpen && (
        <Modal onClose={onClose} heading={title}>
          <MembroUnidadeForm initialValues={initialValues} onSubmit={onClose} onClose={onClose} />
        </Modal>
      )}
    </ModalTransition>
  );
};

export default MembroUnidadeModal;
